"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateOptions = validateOptions;
exports.collectElememnts = collectElememnts;
exports.checkWindowWidth = checkWindowWidth;
exports.getRequiredRowSize = getRequiredRowSize;
exports.unsetHeights = unsetHeights;
exports.updateRow = updateRow;
exports.startResize = startResize;
exports.collectContainer = collectContainer;
exports.collectExclude = collectExclude;
exports["default"] = exports.defaultOptions = void 0;

var _lodash = require("lodash");

var _utils = require("./utils");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var defaultOptions = {
  global: false,
  delay: 200,
  widths: [],
  child: null,
  exclude_get: null,
  exclude_set: null,
  before_init: null,
  after_init: null,
  before_resize: null,
  after_resize: null,
  after_destroy: null
};
/**
 * validate options passed by end user
 * @param  {object} options
 * @return {object}         found errors by paramater
 */

exports.defaultOptions = defaultOptions;

function validateOptions(options) {
  var errors = {}; // Global must be a boolean

  if (typeof options.global !== 'boolean') {
    (0, _lodash.set)(errors, 'global.type', 'global option should be boolean');
  } // delay must be an int of 0 or more


  if (typeof options.delay !== 'number' || options.delay < 0 || options.delay !== 0 && options.delay % 1 !== 0) {
    // eslint-disable-line max-len
    (0, _lodash.set)(errors, 'delay.type', 'delay option should be an integer');
  } // Callabcks must be null or a function


  for (var _i = 0, _arr = ['before_init', 'after_init', 'before_resize', 'after_resize', 'after_destroy']; _i < _arr.length; _i++) {
    var attribute = _arr[_i];

    // eslint-disable-line max-len
    if (typeof options[attribute] !== 'function' && options[attribute] !== null) {
      (0, _lodash.set)(errors, "".concat(attribute, ".type"), "".concat(attribute, " option is not a valid callback"));
    }
  } // Child must be a string or null


  if (typeof options.child !== 'string' && options.child !== null && options.child !== '') {
    (0, _lodash.set)(errors, 'child.type', 'child option must be a string or null');
  } // Exclusions should be a string, NodeList, element or null


  for (var _i2 = 0, _arr2 = ['exclude_get', 'exclude_set']; _i2 < _arr2.length; _i2++) {
    var _attribute = _arr2[_i2];

    if (options[_attribute] !== null && typeof options[_attribute] !== 'string' && !(0, _utils.isElement)(options[_attribute]) && !(0, _utils.isNodeList)(options[_attribute])) {
      (0, _lodash.set)(errors, "".concat(_attribute, ".type"), "".concat(_attribute, " option must be a string, Nodelist, element or null"));
    }
  } // Widths must be a vlaid multi dimensional array


  if (options.widths instanceof Array !== true) {
    (0, _lodash.set)(errors, 'widths.type', 'widths option should be an array');
  } else {
    var _iterator = _createForOfIteratorHelper(options.widths),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var width = _step.value;

        // Individual widths must only have 2 paeramaters
        if (width instanceof Array !== true || width.length !== 2) {
          (0, _lodash.set)(errors, 'widths.format', 'width options should be an array');
          break;
        } // The size must be a int of 0 or more


        if (typeof width[0] !== 'number' || width[0] < 0 || width[0] !== 0 && width[0] % 1 !== 0) {
          (0, _lodash.set)(errors, 'widths.format.size', 'width sizes must be an integer of 0 or more');
          break;
        } // The column count must be an int of 1 or more


        if (typeof width[1] !== 'number' || width[1] < 1 || width[1] % 1 !== 0) {
          (0, _lodash.set)(errors, 'widths.format', 'width columns must be an integer of 1 or more');
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return errors;
}
/**
 * Build object of references to objects we want to modify heigths of
 * @param  {element} container  cotnainer element
 * @param  {string | null} childQuery css query sleector content
 * @return {array}
 */


function collectElememnts(container, childQuery) {
  if (!container || !container.children.length) {
    return [];
  }

  if (childQuery) {
    var elements = [];

    var _iterator2 = _createForOfIteratorHelper(container.children),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var el = _step2.value;
        var result = el.querySelector(childQuery);

        if (result) {
          elements.push(result);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return elements;
  }

  return (0, _lodash.toArray)(container.children);
}
/**
 * Determine if the window size is greater than the supplied width
 * @param  {int} width screen width to check
 * @return {bool}
 */


function checkWindowWidth(width) {
  if (window.matchMedia) {
    return window.matchMedia("screen and (min-width:".concat(width, "px)")).matches;
  }

  if (window.innerWidth > width) {
    return true;
  }

  return false;
}
/**
 * Work out how many columns we need based on current screen size and options
 * @param  {boolean} globalOption global option
 * @param  {array} widthsOption   widths array from options
 * @return {integer}              number of colums to run logic on
 */


function getRequiredRowSize(globalOption, widthsOption) {
  if (globalOption) {
    return -1;
  }

  var _iterator3 = _createForOfIteratorHelper(widthsOption),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var width = _step3.value;

      if (checkWindowWidth(width[0])) {
        return width[1];
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return -1;
}
/**
 * Remove any existing javascript set height on all elements
 * @param {array} elements
 */


function unsetHeights(elements) {
  var _iterator4 = _createForOfIteratorHelper(elements),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var el = _step4.value;
      el.style.removeProperty('height');
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
}
/**
 * Update heights of supplied row of elemenrts
 * @param  {array} array of elements to resize
 * @return
 */


function updateRow(row) {
  var excludeGet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var excludeSet = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  // If we only have one row reset the heights
  if (row.length === 1) {
    return;
  } // calculate largest element in row


  var maxHeight = 0;

  var _iterator5 = _createForOfIteratorHelper(row),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var el = _step5.value;

      if (!excludeGet.includes(el)) {
        maxHeight = el.offsetHeight > maxHeight ? el.offsetHeight : maxHeight;
      }
    } // set heights of all elements in row

  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  var _iterator6 = _createForOfIteratorHelper(row),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var _el = _step6.value;

      if (!excludeSet.includes(_el)) {
        _el.style.height = "".concat(maxHeight, "px");
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
}
/**
 * Trigger funciton to kickoff resizeTo
 * @param  {array} elements
 * @param  {object} options
 * @return
 */


function startResize(elements, options, exclude) {
  // trigger callback
  if (typeof options.before_resize === 'function') {
    options.before_resize();
  } // remove old heights from elements


  unsetHeights(elements); // work out needed number of collumns required per row

  var rowSize = getRequiredRowSize(options.global, options.widths); // split elements by collumns required

  var rows;

  if (rowSize > 0) {
    rows = (0, _lodash.chunk)(elements, rowSize);
  } else {
    rows = [elements];
  } // Update rows


  var _iterator7 = _createForOfIteratorHelper(rows),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var row = _step7.value;
      updateRow(row, exclude.get, exclude.set);
    } // trigger callback

  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  if (typeof options.after_resize === 'function') {
    options.after_resize();
  }
}
/**
 * collec tthe container element depending if a string or the element its self was passed
 * @param  {string | object} value the container element passed
 * @return {object}          container element
 */


function collectContainer(value) {
  if (typeof value === 'string') {
    return document.querySelector(value);
  }

  return value;
}
/**
 * Collect elemenets used for exclusion of getting / setting based on user options
 * @param  {mixed} value
 * @return {array}
 */


function collectExclude(value) {
  if (!value) {
    return [];
  }

  if (typeof value === 'string') {
    return (0, _lodash.toArray)(document.querySelectorAll(value));
  }

  if ((0, _utils.isElement)(value)) {
    return [value];
  }

  if ((0, _utils.isNodeList)(value)) {
    return (0, _lodash.toArray)(value);
  }

  return [];
}
/**
 * Module entrypoint
 * @type {class}
 */


var ResponsiveHeight = /*#__PURE__*/function () {
  /**
   * Construct the instance
   * @param {element} el   html cotnainer element
   * @param {object} opts options object
   */
  function ResponsiveHeight(container) {
    var _this = this;

    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ResponsiveHeight);

    this.container = collectContainer(container);
    this.options = (0, _utils.mergeObjects)(opts, defaultOptions);
    this.handleResize = (0, _utils.debounce)(function () {
      _this.refresh();
    }, this.options.delay);
    this.init();
  }
  /**
   * Initialise the module
   */


  _createClass(ResponsiveHeight, [{
    key: "init",
    value: function init() {
      var validation = validateOptions(this.options);

      if (!(0, _lodash.isEmpty)(validation)) {
        console.error('Errors found in options'); // eslint-disable-line no-console
        // TODO display validaton errors to user in a clean way

        console.error(validation); // eslint-disable-line no-console
      } else {
        // trigger clalback
        if (typeof this.options.before_init === 'function') {
          this.options.before_init();
        } // Collect an array of elements to run logic on


        this.collect(); // Run initial resize event

        startResize(this.elements, this.options, this.exclude); // Bind resize evenrt

        window.addEventListener('resize', this.handleResize); // trigger clalback

        if (typeof this.options.after_init === 'function') {
          this.options.after_init();
        }
      }
    }
    /**
     * Trigger resize event
     */

  }, {
    key: "refresh",
    value: function refresh() {
      startResize(this.elements, this.options, this.exclude);
    }
    /**
     * Colelct elements to be used for resizing
     */

  }, {
    key: "collect",
    value: function collect() {
      this.elements = collectElememnts(this.container, this.options.child);
      this.exclude = {
        get: collectExclude(this.options.exclude_get),
        set: collectExclude(this.options.exclude_set)
      };
    }
    /**
     * Reset the container and elements to their default state
     */

  }, {
    key: "destroy",
    value: function destroy() {
      unsetHeights(this.elements);
      window.removeEventListener('resize', this.handleResize); // trigger clalback

      if (typeof this.options.after_destroy === 'function') {
        this.options.after_destroy();
      }
    }
  }]);

  return ResponsiveHeight;
}();

exports["default"] = ResponsiveHeight;